// REQ-P1-06b: リマインダー参照APIの契約型付きクライアント。

import { api, type paths } from './client';
import { ApiStatusError } from './templates';

type ReminderScheduleResponse = NonNullable<
  paths['/reminders/schedules/{scheduleId}']['get']['responses'][200]['content']
>['application/json'];

export async function getReminderSchedule(
  scheduleId: string | number
): Promise<Record<string, unknown> | null> {
  const normalizedScheduleId = Number(scheduleId);
  if (!Number.isInteger(normalizedScheduleId)) throw new ApiStatusError(400);
  const { data, response } = await api.GET('/reminders/schedules/{scheduleId}', {
    params: { path: { scheduleId: normalizedScheduleId } },
  });
  if (!response.ok || !data) return null;
  const schedule = (data as ReminderScheduleResponse).schedule;
  return schedule && typeof schedule === 'object' ? (schedule as Record<string, unknown>) : null;
}
